import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e068fc7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navBox"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_3 = {
  class: "rightBtnBox"
};
const _hoisted_4 = {
  class: "phoneBtn"
};
const _hoisted_5 = {
  style: {
    "display": "none"
  }
};
const _hoisted_6 = {
  class: "phoneBtnLine"
};
const _hoisted_7 = {
  class: "navBtn PCBtn"
};
const _hoisted_8 = {
  style: {
    "display": "none"
  }
};
const _hoisted_9 = {
  class: "link-block"
};
const _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popover = _resolveComponent("van-popover");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
    height: "40",
    width: "100",
    src: require('@/assets/img/logo.png')
  }, null, 8, ["src"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toServer()),
    class: "phoneBtn"
  }, [_createVNode(_component_van_icon, {
    color: "#000",
    size: "28",
    name: require('@/assets/img/server.png')
  }, null, 8, ["name"])]), _createVNode(_component_van_popover, {
    show: _ctx.showPopover,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => _ctx.showPopover = $event),
    actions: _ctx.actions,
    onSelect: _ctx.onSelect,
    placement: "bottom-end"
  }, {
    reference: _withCtx(() => [_createElementVNode("button", _hoisted_4, [_createVNode(_component_van_icon, {
      color: "#000",
      size: "28",
      name: require('@/assets/img/lang.png')
    }, null, 8, ["name"])])]),
    action: _withCtx(({
      action
    }) => [_createElementVNode("div", null, _toDisplayString(action.name), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(action.code), 1)]),
    _: 1
  }, 8, ["show", "actions", "onSelect"]), _createElementVNode("button", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.visible = true),
    class: "phoneBtn"
  }, [_createVNode(_component_van_icon, {
    color: "#000",
    size: "28",
    name: "wap-nav"
  })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/memberCenter' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.$router.push('/memberCenter'))
  }, _toDisplayString(_ctx.$t('navtab.memberCenter')), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/bindBank' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push('/bindBank'))
  }, _toDisplayString(_ctx.$t('navtab.bindBank')), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/memberEdit' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.push('/memberEdit'))
  }, _toDisplayString(_ctx.$t('navtab.editInfo')), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/store' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.$router.push('/store'))
  }, _toDisplayString(_ctx.$t('navtab.store')), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/withdraw' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.$router.push('/withdraw'))
  }, _toDisplayString(_ctx.$t('navtab.withdraw')), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(_ctx.$route.path === '/record_store' ? 'activeNav navBtn PCBtn' : 'navBtn PCBtn')
  }, [_createElementVNode("a", {
    onClick: _cache[8] || (_cache[8] = $event => _ctx.$router.push('/record_store'))
  }, _toDisplayString(_ctx.$t('navtab.record')), 1)], 2), _createElementVNode("span", _hoisted_7, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.logOut()),
    href: ""
  }, _toDisplayString(_ctx.$t('navtab.logout')), 1)]), _createVNode(_component_van_icon, {
    onClick: _cache[10] || (_cache[10] = $event => _ctx.toServer()),
    class: "PCBtn",
    color: "#000",
    size: "28",
    name: require('@/assets/img/server.png')
  }, null, 8, ["name"]), _createVNode(_component_van_popover, {
    show: _ctx.showPcPopover,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => _ctx.showPcPopover = $event),
    actions: _ctx.actions,
    onSelect: _ctx.onSelect,
    placement: "bottom-end"
  }, {
    reference: _withCtx(() => [_createVNode(_component_van_icon, {
      class: "PCBtn",
      color: "#000",
      size: "28",
      name: require('@/assets/img/lang.png')
    }, null, 8, ["name"])]),
    action: _withCtx(({
      action
    }) => [_createElementVNode("div", null, _toDisplayString(action.name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(action.code), 1)]),
    _: 1
  }, 8, ["show", "actions", "onSelect"])])])]), _createElementVNode("div", {
    class: _normalizeClass(_ctx.visible === true ? 'mobile-link-block show' : 'mobile-link-block')
  }, [_createElementVNode("div", {
    onClick: _cache[12] || (_cache[12] = $event => _ctx.visible = false),
    class: "close-icon"
  }, [_createVNode(_component_van_icon, {
    name: "cross"
  })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: require('@/assets/img/logo.png')
  }, null, 8, _hoisted_10), _createElementVNode("a", {
    onClick: _cache[13] || (_cache[13] = $event => _ctx.routerPush('/memberCenter'))
  }, _toDisplayString(_ctx.$t('navtab.memberCenter')), 1), _createElementVNode("a", {
    onClick: _cache[14] || (_cache[14] = $event => _ctx.routerPush('/bindBank'))
  }, _toDisplayString(_ctx.$t('navtab.bindBank')), 1), _createElementVNode("a", {
    onClick: _cache[15] || (_cache[15] = $event => _ctx.routerPush('/memberEdit'))
  }, _toDisplayString(_ctx.$t('navtab.editInfo')), 1), _createElementVNode("a", {
    onClick: _cache[16] || (_cache[16] = $event => _ctx.routerPush('/store'))
  }, _toDisplayString(_ctx.$t('navtab.store')), 1), _createElementVNode("a", {
    onClick: _cache[17] || (_cache[17] = $event => _ctx.routerPush('/withdraw'))
  }, _toDisplayString(_ctx.$t('navtab.withdraw')), 1), _createElementVNode("a", {
    onClick: _cache[18] || (_cache[18] = $event => _ctx.routerPush('/record_store'))
  }, _toDisplayString(_ctx.$t('navtab.record')), 1), _createElementVNode("a", {
    onClick: _cache[19] || (_cache[19] = $event => _ctx.logOut()),
    class: "Signout-button btn"
  }, _toDisplayString(_ctx.$t('navtab.logout')), 1)])], 2)], 64);
}